module.exports = __webpack_public_path__ + "img/애고미_이모티콘-08.3adc2ae.png";